import React from "react";
import "./styles.css";
import { DefaultAvatar } from "../DefaultAvatar";

type AccountItemProps = {
    account: {
        user: {
            name: string;
            avatarColor?: string;
        };
    };
};

export const AccountItem: React.FC<AccountItemProps> = ({ account }) => {
    const { user } = account;

    return (
        <div className="flex items-center gap-3">
            <DefaultAvatar name={user.name} color={user.avatarColor} />
            <div className="flex flex-col">
                <div className="text-[15px] font-semibold text-slate-900">
                    {user.name}
                </div>
                <div className="mt-0.5 text-xs text-[#818c99]">риэлтор</div>
            </div>
        </div>
    );
};
